import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  showTag?: boolean;
  variant?: 'default' | 'compact';
}

export default function ArticleCard({ article, showTag = true, variant = 'default' }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block flex-shrink-0 w-[260px] md:w-[280px] cursor-pointer"
    >
      <div className="relative rounded-2xl overflow-hidden bg-background-100">
        {showTag && article.isExclusive && (
          <span className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-label rounded-md">
            独家
          </span>
        )}
        {showTag && article.isHot && !article.isExclusive && (
          <span className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-label rounded-md">
            热门
          </span>
        )}
        <div className="w-full h-[180px] md:h-[200px] overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 17吃瓜网`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </div>
      <div className="mt-3 px-1">
        <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {article.title}
        </h3>
        {variant === 'default' && (
          <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
        )}
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
          <span>{article.category}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{article.publishedAt}</span>
        </div>
      </div>
    </Link>
  );
}